import LocaleUtils from 'qwc2/utils/LocaleUtils';

const DirtyUtils = {
    // Returns true if the window may be left: it has no unsaved changes, or the user agreed to discard them
    confirmLeave(state, windowId) {
        if (!state.dirty[windowId]) {
            return true;
        }
        return window.confirm(LocaleUtils.tr("featuredetails.unsavedchanges"));
    }
};

export default DirtyUtils;
